import { AjaxStreamCallback, AjaxWrapper, HttpMethod } from 'generic/ajaxWrapper'

export interface NewsletterContentChatResponse {
  message?: string
  summary?: string
  topics?: string[]
  done?: boolean
  error?: string
}

export type NewsletterContentChatCallback = (response: NewsletterContentChatResponse | null) => void

export const streamNewsletterContentChatResponse = (
  communityId: string,
  payload: any,
  callback: NewsletterContentChatCallback
) => {
  const url = `${AjaxWrapper.getServerUrl()}/ai/${communityId}/chat`

  const responseParser: AjaxStreamCallback = (success: boolean, chunk: string) => {
    if (!chunk) {
      callback(null)
      return
    }

    if (!success) {
      callback({
        done: true,
        error: chunk,
      })
      return
    }

    // Parse SSE format: "data: {...}\n\ndata: {...}\n\n"
    const lines = chunk.split('\n')
    lines.forEach((line) => {
      if (line.startsWith('data: ')) {
        try {
          const jsonStr = line.substring(6) // Remove "data: " prefix
          const data = JSON.parse(jsonStr)
          callback(data)
        } catch (e) {
          // Ignore parse errors for incomplete chunks
        }
      }
    })
  }

  AjaxWrapper.stream(url, HttpMethod.POST, payload, responseParser)
}
